module.exports = __webpack_public_path__ + "static/media/left.f722c6cc.svg";